var SpriteSymbol = require("../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "paper-clip",
  "use": "paper-clip-usage",
  "viewBox": "0 0 256 256",
  "content": "<symbol viewBox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\" id=\"paper-clip\"><rect fill=\"none\" height=\"256\" width=\"256\" /><path d=\"M160,80,76.7,164.7a16,16,0,0,0,22.6,22.6L198.6,86.6a32,32,0,0,0-45.2-45.2L54.1,142.1a47.9,47.9,0,0,0,67.8,67.8L204,128\" fill=\"none\" stroke=\"#666\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"16\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id